import {
  ActionIcon,
  Alert,
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Group,
  Image,
  LoadingOverlay,
  NumberInput,
  Select,
  Stack,
  Text,
  TextInput,
  Textarea,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import {
  IconAlertSquareRoundedFilled,
  IconBuildingWarehouse,
  IconCircleCheckFilled,
  IconPhone,
  IconSearch,
  IconSend,
} from "@tabler/icons-react";
import { useEffect, useState, useTransition } from "react";
import { useParams } from "react-router-dom";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";

export interface TblWarrantyReceipt {
  id: number;
  customerName: string | null;
  phoneNumber: string | null;
  email: string | null;
  provinceId: number | string | null;
  communeId: number | string | null;
  address: string | null;
  quantity: number | null;
  itemNote?: string | null;
  errorNote?: string | null;
  status?: string | null;
  attribute1: string | null;
  attribute2?: string | null;
  attribute3?: string | null;
  attribute4?: string | null;
  attribute5?: string | null;
  attribute6?: string | null;
  attribute7?: string | null;
  attribute8?: string | null;
  attribute9?: string | null;
  attribute10?: string | null;
  createBy?: number | null;
  createDate?: string | null; // hoặc Date nếu bạn parse về Date
  lastUpdateBy?: number | null;
  lastUpdateDate?: string | null; // hoặc Date nếu bạn parse về Date
}

export default function SendWarrantyClaim() {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [provinceId, setProvinceId] = useState<string | null>(null);
  const [reponseStutus, setReponseStutus] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [isPending, startTransition] = useTransition();
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [fistCheck, setFistCheck] = useState(false);

  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [isOldCustomer, setIsOldCustomer] = useState<boolean | null>(null);
  const [numericalOrder, setNumericalOrder] = useState<string | null>(null);
  const [notification, setNotification] = useState<{
    show: boolean;
    success: boolean;
    message: string;
  }>({ show: false, success: false, message: "" });

  const [dataMeetingAddress, setDataMeetingAddress] =
    useState<TblWarrantyReceipt>({
      id: 0,
      customerName: null,
      phoneNumber: null,
      provinceId: null,
      communeId: null,
      address: null,
      email: null,
      quantity: null,
      attribute1: null,
    });

  const innitStateSearch = {
    id: 0,
    customerName: null,
    phoneNumber: null,
    provinceId: null,
    communeId: null,
    address: null,
    email: null,
    quantity: 1,
    itemNote: null,
    errorNote: null,
    errorDescription: null,
    attribute1: null,
  };

  const nameBranch =
    dataBranch.find((ele) => String(ele.value) === String(id))?.text ??
    "Chưa có chi nhánh";

  const form = useForm<TblWarrantyReceipt>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: innitStateSearch,
    validate: {
      phoneNumber: (value) =>
        !value
          ? "Vui lòng nhập số điện thoại"
          : !/^\d{9,10}$/.test(value)
            ? "Số điện thoại phải đủ 9 đến 10 chữ số"
            : null,

      customerName: (value) => (!value ? "Vui lòng nhập họ và tên" : null),

      provinceId: (value) => (!value ? "Vui lòng chọn Tỉnh/TP" : null),

      communeId: (value) => (!value ? "Vui lòng chọn Phường/Xã" : null),

      address: (value) => (!value ? "Vui lòng nhập địa chỉ cụ thể" : null),

      quantity: (value) =>
        !value || value < 1 ? "Số lượng phải lớn hơn 0" : null,

      itemNote: (value) =>
        !value ? "Vui lòng nhập danh sách sản phẩm cần bảo hành" : null,
    },
  });

  const handleOnChange = (value: any, key: string) => {
    startTransition(() => {
      if (value !== "Invalid date") {
        setDataMeetingAddress((prevData) => ({ ...prevData, [key]: value }));
      } else {
        setDataMeetingAddress((prevData) => ({ ...prevData, [key]: "" }));
      }
    });
    if (key === "phoneNumber") {
      setIsOldCustomer(null); // reset trạng thái khi người dùng sửa số
    }
  };

  //Đây là api lấy dữ liệu tỉnh thành
  const getDataProvinceSelect = async () => {
    const getData = await getProvinceSelectNew();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.id != null && item.name != null)
        ?.map((item: any) => ({
          value: String(item.id),
          label: String(item.name),
        })),
    );
  };
  //Đây là api lấy dữ liệu các phường/xã theo tỉnh/thành phố
  const getDataCommuneSelect = async () => {
    if (provinceId !== null || dataMeetingAddress.provinceId) {
      const getData = await getCommuneSelectNew(
        String(provinceId ? provinceId : dataMeetingAddress.provinceId || ""),
      );
      setDataCommuneSelect(
        getData
          ?.filter((item: any) => item.value != null && item.text != null)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          })),
      );
    }
  };
  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranch(result);
    }
  };

  const fetchDataListTelephone = async () => {
    const response = await repositoryMdm.get<
      MessageResponse<TblWarrantyReceipt>
    >(
      `/api/v1/TblWarrantyReceipt/create?phoneNumber=${dataMeetingAddress.phoneNumber}`,
    );

    if (response && response.success) {
      setFistCheck(true);
      const result: any = response.data ?? {};
      const allValuesNullOrZero = Object.values(result).every(
        (val) => val === null || val === 0,
      );
      if (!allValuesNullOrZero) {
        setIsOldCustomer(true);

        // API địa chỉ mới -> provinceId/communeId cũ có thể không map được sang dữ liệu mới.
        // Nếu không tìm thấy trong dữ liệu mới thì để null để người dùng tự nhập lại.
        let validProvinceId: string | null =
          result.provinceId != null ? String(result.provinceId) : null;
        let validCommuneId: string | null =
          result.communeId != null ? String(result.communeId) : null;

        const isProvinceValid =
          validProvinceId != null &&
          dataProvinceSelect.some(
            (item) => String(item.value) === validProvinceId,
          );

        if (!isProvinceValid) {
          validProvinceId = null;
          validCommuneId = null;
        } else if (validCommuneId != null) {
          const communeData = await getCommuneSelectNew(
            String(validProvinceId),
          );
          const isCommuneValid = communeData?.some(
            (item: any) => String(item.value) === validCommuneId,
          );
          if (!isCommuneValid) {
            validCommuneId = null;
          }
        }

        const normalizedResult = {
          ...result,
          provinceId: validProvinceId,
          communeId: validCommuneId,
        };

        setProvinceId(validProvinceId);

        setDataMeetingAddress((prevData) => ({
          ...prevData,
          ...normalizedResult,
          attribute1: String(id),
        }));

        form.setValues({
          ...form.getValues(),
          ...normalizedResult,
          attribute1: String(id),
        });
      } else {
        setIsOldCustomer(false);
      }
    }
  };

  const handleSubmit = async (values: TblWarrantyReceipt) => {
    setLoading(true);
    try {
      const requestData: TblWarrantyReceipt = {
        ...values,
        // provinceId: values.provinceId ?? provinceId ?? "",
        // communeId: values.communeId ?? communeId ?? "",
      };

      const response = await repositoryMdm.post<
        MessageResponse<TblWarrantyReceipt>
      >("/api/v1/TblWarrantyReceipt/create", requestData);
      if (response && response.success) {
        NotificationExtension.Success("Gửi yêu cầu thành công !");
        setReponseStutus(true);
        setIsLoading(true);
        setNumericalOrder(
          response?.data?.attribute2 != null
            ? String(response.data.attribute2)
            : null,
        );
      } else {
        NotificationExtension.Fails(
          "Gửi yêu cầu thất bại. Vui lòng thử lại sau !",
        );
      }
    } catch (error) {
      NotificationExtension.Fails(
        "Gửi yêu cầu thất bại. Vui lòng thử lại sau !",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (provinceId !== null || dataMeetingAddress.provinceId) {
      getDataCommuneSelect();
    }
  }, [provinceId, dataMeetingAddress.provinceId]);

  useEffect(() => {
    getDataProvinceSelect();
    fetchDataBranch();
  }, []);

  useEffect(() => {
    form.setValues((prev) => ({
      ...prev,
      branchId: JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
        ?.branchId,
      // branchId: 221,
      isReceive: false,
      communeId: Number(dataMeetingAddress.communeId),
      provinceId: Number(dataMeetingAddress.provinceId),
    }));
  }, [dataMeetingAddress, dataProvinceSelect, dataCommuneSelect]);

  useEffect(() => {
    form.setFieldValue("customerName", dataMeetingAddress.customerName ?? "");
  }, [dataMeetingAddress.customerName]);

  useEffect(() => {
    form.setFieldValue("address", dataMeetingAddress.address ?? "");
  }, [dataMeetingAddress.address]);

  useEffect(() => {
    if (dataMeetingAddress.phoneNumber) {
      form.setValues((prev) => ({
        ...prev,
        phoneNumber: dataMeetingAddress.phoneNumber,
      }));
    }
  }, [dataMeetingAddress.phoneNumber]);

  useEffect(() => {
    if (id !== null) {
      form.setValues((prev) => ({
        ...prev,
        attribute1: id,
      }));
    }
  }, [id]);

  return (
    <>
      <Stack>
        <Flex
          bg="#007be5"
          justify={"space-between"}
          align={"center"}
          px={20}
          py={10}
        >
          <div style={{ width: "100px", height: "50px" }}>
            <Image
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
              src="https://hanoicomputercdn.com/media/lib/30-05-2024/favicon-hacom-2024.png"
              alt="Logo"
            />
          </div>
          <Flex gap={3} align="center">
            <IconPhone style={{ color: "#fff" }} size={22} />
            <Text style={{ color: "#fff" }} ml={5} size="lg" fw={600}>
              1900 1903
            </Text>
          </Flex>
        </Flex>
        <Container size="sm" pt={0} py="xl">
          <Flex gap={10} align="center" pb="10px">
            <IconBuildingWarehouse size={16} />
            <Text c="red" fw="bold">
              {nameBranch}
            </Text>
          </Flex>
          {reponseStutus && (
            <Box
              style={{
                minHeight: 460,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "24px 8px",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  maxWidth: 356,
                  background: "#eef4fb",
                  borderRadius: 26,
                  padding: 16,
                }}
              >
                <Box
                  style={{
                    position: "relative",
                    background: "#fff",
                    border: "1px solid #dbe6f3",
                    borderRadius: 18,
                    boxShadow: "0 12px 30px rgba(2, 79, 147, 0.12)",
                  }}
                >
                  <Flex
                    direction="column"
                    align="center"
                    gap={8}
                    style={{ padding: "20px 22px 14px" }}
                  >
                    <Text
                      style={{
                        fontSize: "11.5px",
                        fontWeight: 800,
                        letterSpacing: "0.16em",
                        textTransform: "uppercase",
                        color: "#007be5",
                      }}
                    >
                      Phiếu tiếp nhận bảo hành
                    </Text>
                    <Flex align="center" gap={6}>
                      <IconCircleCheckFilled
                        size={16}
                        style={{ color: "#16a34a" }}
                      />
                      <Text
                        style={{
                          fontSize: "12.5px",
                          fontWeight: 700,
                          color: "#16a34a",
                        }}
                      >
                        Đã tiếp nhận yêu cầu
                      </Text>
                    </Flex>
                  </Flex>

                  <Box style={{ position: "relative", height: 22 }}>
                    <Box
                      style={{
                        position: "absolute",
                        left: 14,
                        right: 14,
                        top: "50%",
                        borderTop: "2px dashed #dbe6f3",
                      }}
                    />
                    <Box
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: -11,
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#eef4fb",
                        transform: "translateY(-50%)",
                      }}
                    />
                    <Box
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: -11,
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#eef4fb",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </Box>

                  <Flex
                    direction="column"
                    align="center"
                    style={{ padding: "6px 22px 22px" }}
                  >
                    <Text
                      style={{
                        fontSize: "12.5px",
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        color: "#5b7089",
                      }}
                    >
                      Số thứ tự của bạn
                    </Text>
                    <Text
                      style={{
                        fontSize: "116px",
                        fontWeight: 800,
                        lineHeight: 1,
                        color: "#007be5",
                        fontVariantNumeric: "tabular-nums",
                      }}
                    >
                      {numericalOrder
                        ? String(numericalOrder).padStart(2, "0")
                        : "—"}
                    </Text>

                    <Stack gap={8} style={{ width: "100%", marginTop: 14 }}>
                      {[
                        {
                          label: "Khách hàng",
                          value: form.getValues().customerName || "-",
                        },
                        {
                          label: "Điện thoại",
                          value: form.getValues().phoneNumber || "-",
                        },
                        { label: "Chi nhánh", value: nameBranch },
                      ].map((it, i) => (
                        <Flex
                          key={i}
                          justify="space-between"
                          align="center"
                          gap={12}
                        >
                          <Text
                            style={{ fontSize: "13.5px", color: "#5b7089" }}
                          >
                            {it.label}
                          </Text>
                          <Text
                            style={{
                              fontSize: "13.5px",
                              fontWeight: 700,
                              color: "#0f2033",
                              textAlign: "right",
                            }}
                          >
                            {it.value}
                          </Text>
                        </Flex>
                      ))}
                    </Stack>

                    <Text
                      style={{
                        marginTop: 16,
                        fontSize: "12.5px",
                        color: "#5b7089",
                        textAlign: "center",
                      }}
                    >
                      Vui lòng giữ số và chờ đến lượt được gọi
                    </Text>
                  </Flex>
                </Box>
              </Box>
            </Box>
          )}
          {!reponseStutus && (
            <>
              <Title
                order={2}
                mb="5px"
                style={{ color: "#228be6", fontSize: "16px" }}
              >
                YÊU CẦU DỊCH VỤ KỸ THUẬT, BẢO HÀNH
              </Title>
              <Text mb="md" style={{ fontSize: "12px" }}>
                Quý khách cần bảo hành hoặc hỗ trợ kỹ thuật, vui lòng gửi yêu
                cầu. Chúng tôi sẽ liên hệ ngay sau khi nhận được.
              </Text>
              <Box
                component="form"
                style={{ position: "relative", width: "100%" }}
                onSubmit={form.onSubmit((e: TblWarrantyReceipt) => {
                  handleSubmit(e);
                })}
              >
                <LoadingOverlay visible={loading} />
                <Stack gap="sm">
                  <Grid>
                    <Grid.Col span={12}>
                      <TextInput
                        label="Số điện thoại"
                        radius={"xl"}
                        size="md"
                        placeholder="Nhập số điện thoại"
                        {...form.getInputProps("phoneNumber")}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/\D/g, "").slice(0, 11);
                          handleOnChange(value, "phoneNumber");
                        }}
                        rightSection={
                          <ActionIcon
                            variant="filled"
                            color="blue"
                            disabled={
                              reponseStutus ||
                              !dataMeetingAddress?.phoneNumber ||
                              dataMeetingAddress.phoneNumber.length < 9 ||
                              dataMeetingAddress.phoneNumber.length > 11
                            }
                            radius={"xl"}
                            bd={"1px solid #007be5"}
                            onClick={fetchDataListTelephone}
                            aria-label="Settings"
                          >
                            <IconSearch
                              style={{ width: "70%", height: "70%" }}
                              stroke={1.5}
                            />
                          </ActionIcon>
                        }
                        onKeyPress={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Delete" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                    </Grid.Col>
                  </Grid>
                  {isOldCustomer === false && (
                    <Alert
                      variant="light"
                      color="blue"
                      radius="lg"
                      title="Khách hàng mới"
                      icon={<IconAlertSquareRoundedFilled size={20} />}
                      style={{ border: "1px solid blue" }} // fix cho `bd` => không phải prop của Mantine
                    >
                      Vui lòng điền đầy đủ thông tin để tiếp tục.
                    </Alert>
                  )}

                  {isOldCustomer === true && (
                    <Alert
                      variant="light"
                      color="#2b9c3f"
                      radius="lg"
                      title="Khách hàng cũ"
                      icon={<IconAlertSquareRoundedFilled size={20} />}
                      style={{ border: "1px solid #2b9c3f" }}
                    >
                      Dữ liệu khách hàng đã được tự động điền.
                    </Alert>
                  )}

                  <Group grow>
                    <TextInput
                      key={form.key("customerName")}
                      label="Họ và tên"
                      disabled={!fistCheck}
                      placeholder="Nhập họ và tên"
                      {...form.getInputProps("customerName")}
                      required
                    />
                    <Select
                      label="Tỉnh/TP"
                      placeholder="Nhập tỉnh/thành phố"
                      data={dataProvinceSelect}
                      value={
                        dataMeetingAddress.provinceId
                          ? dataMeetingAddress.provinceId.toString()
                          : null
                      }
                      searchable
                      disabled={!fistCheck}
                      clearable
                      nothingFoundMessage="Không tìm thấy dữ liệu !"
                      withAsterisk
                      {...form.getInputProps("provinceId")}
                      onChange={(e) => {
                        setProvinceId(e);
                        handleOnChange(e, "provinceId");
                        handleOnChange(null, "communeId");
                      }}
                    />
                    {/* <TextInput
                  disabled={reponseStutus}
                  label="Email"
                  placeholder="Nhập email"
                  {...form.getInputProps("email")}
                  required
                /> */}
                  </Group>
                  <Group grow>
                    <Select
                      label="Phường/Xã"
                      placeholder="Nhập phường/xã"
                      data={dataCommuneSelect}
                      searchable
                      clearable
                      disabled={
                        dataMeetingAddress.communeId
                          ? false
                          : provinceId === null
                      }
                      value={
                        dataMeetingAddress.communeId
                          ? dataMeetingAddress.communeId?.toString()
                          : null
                      }
                      nothingFoundMessage="Không tìm thấy dữ liệu !"
                      withAsterisk
                      {...form.getInputProps("communeId")}
                      onChange={(e) => {
                        handleOnChange(e, "communeId");
                      }}
                    />
                    <TextInput
                      key={form.key("address")}
                      label="Địa chỉ cụ thể"
                      disabled={!fistCheck}
                      placeholder="Nhập địa chỉ chi tiết"
                      {...form.getInputProps("address")}
                      required
                    />
                  </Group>
                  <NumberInput
                    defaultValue={1}
                    key={form.key("quantity")}
                    label="Số lượng sản phẩm"
                    placeholder="Nhập số lượng"
                    disabled={!fistCheck}
                    min={1}
                    {...form.getInputProps("quantity")}
                    required
                  />
                  <Textarea
                    key={form.key("itemNote")}
                    label="Sản phẩm bảo hành"
                    disabled={!fistCheck}
                    placeholder="Nhập danh sách sản phẩm cần bảo hành"
                    {...form.getInputProps("itemNote")}
                    minRows={3}
                    required
                  />
                  <Textarea
                    key={form.key("errorNote")}
                    label="Ghi chú lỗi"
                    disabled={!fistCheck}
                    placeholder="Mô tả lỗi gặp phải"
                    {...form.getInputProps("errorNote")}
                    minRows={5}
                  />
                  <Button
                    loading={loading}
                    style={{ position: "sticky", bottom: 10 }}
                    radius="xl"
                    disabled={reponseStutus || !fistCheck}
                    variant="filled"
                    color="#007be5"
                    type="submit"
                    size="md"
                    mt="xs"
                    leftSection={<IconSend size={14} />}
                  >
                    Gửi yêu cầu bảo hành
                  </Button>
                </Stack>
              </Box>
            </>
          )}
        </Container>
      </Stack>
    </>
  );
}
